import moment from 'moment';

import { IAdminEvent } from '../../../store/admin/events/store';
import { ISeason } from '../../../store/seasons/store';

import { getEventsByMonths, IEventsByMonth } from '../../../contrib/utils';

interface IEventsByYear {
  [year: number]: IAdminEvent[];
}

interface IEventsByYearAndMonth {
  [year: number]: IEventsByMonth;
}

export const useEventsByYearAndMonth = (
  clubEvents: IAdminEvent[],
  currentSeason: ISeason | undefined
) => {
  const eventsByYear: IEventsByYear = clubEvents.reduce((acc: IEventsByYear, event) => {
    const year = moment(event.start).year();

    if (!(!!currentSeason && event.season && event.season.id === currentSeason.id)) {
      return acc;
    }

    return { ...acc, [year]: [...(!!acc[year] ? acc[year] : []), event] };
  }, {});

  const eventsByYearAndMonth: IEventsByYearAndMonth = Object.keys(eventsByYear).reduce(
    (acc, year) => ({ ...acc, [year]: getEventsByMonths(eventsByYear[Number(year)]) }),
    {}
  );

  return eventsByYearAndMonth;
};
